import { eDmKhoiNganhActionsObj } from "../../action-types/category/IDmKhoiNganhActions";
import { generateActions } from "../generateActions";

export const khoiNganhActions = {
  ...generateActions(eDmKhoiNganhActionsObj, "KHOI_NGANH"),
};
